import { RadioGroupComponent } from '../../../radio/RadioGroup';
import { TemplateFormFieldProps } from '../../interfaces/template-form';
import { TemplateFormRadioGroupFieldMetaProps } from './interfaces/template-form-radio-group-field-meta';

export function TemplateFormRadioGroupField({ metadata, form, field }: TemplateFormFieldProps) {
  const { children, ...radioProps } = metadata as TemplateFormRadioGroupFieldMetaProps;

  return (
    <RadioGroupComponent
      {...radioProps}
      onChange={val => {
        (async () => {
          await form.setFieldValue(field.name, val);
        })();
      }}
    >
      {children}
    </RadioGroupComponent>
  );
}
